export default function () {
  this.loadPlan()
}
